import { useModal } from '../contexts';
import Modal from './Modal';
import { useTranslation } from 'react-i18next';

interface Props {
  onConfirm: () => void;
  message?: string;
  block?: any;
}

function WorkflowModalRemoveBlock(props: Props) {
  const { closeModal } = useModal();
  const { t } = useTranslation();

  let deleteText = <p className="font-semibold text-sm text-gray-500">{props.message}</p>;

  if (props.block?.documentType)
    deleteText = <p className="font-semibold text-sm text-gray-500">{t("This will NOT delete the attached file from your Google Drive.")}</p>

  if (props.block?.emailType)
    deleteText = <p className="font-semibold text-sm text-gray-500">{t("This will delete the email content and settings.")}</p>

  return (
    <Modal
      title={
        <h3 className="font-gilroy font-semibold text-xl text-red">
          {t("Remove Block")}
        </h3>
      }
      subtitle={deleteText}
      secondaryButtonProps={{ text: t("Cancel"), onClick: closeModal }}
      primaryButtonProps={{ text: t("Confirm"), onClick: props.onConfirm }}
    />
  );
}

export default WorkflowModalRemoveBlock;
